
import { auth} from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes"
import { Component,Mixins} from "vue-property-decorator"
import Common from '@/mixins/common';
import PhoneAuth from "@/components/PhoneAuth.vue"

@Component({
  components: {
    
    PhoneAuth
  }
})

export default class SignUpPhone extends Mixins(Common) {
  isLoading = false
  notice = {} as NoticeProps
  

  async created(){
    console.trace('created');
    auth.signOut();
  }

 
 
 async mounted(){
  console.trace('mounted');
 }

  destroyed() {
    console.trace('destroyed');
  }

}
